module.exports = __webpack_public_path__ + "img/蔓荆子.83f0f816.jpg";